import Vue from 'vue'
import Router from 'vue-router'
import Search from '@/views/search'
import Result from '@/views/result'
import Activity from '@/views/activity'
import AcvicityDetail from '@/views/activity-detail'
import Coupons from '@/views/coupons'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/search',
            name: 'search',
            component: Search
        },
        {
            path: '/result',
            name: 'result',
            component: Result
        },
        {
            path: '/activity',
            name: 'activity',
            component: Activity
        },
        {
            path: '/activity-detail',
            name: 'activity-detail',
            component: AcvicityDetail
        },
        {
            path: '/coupons',
            name: 'coupons',
            component: Coupons
        },
    ]
})